export var ThresholdMode;
(function (ThresholdMode) {
    ThresholdMode["THRESHOLD_MODE_ABSOLUTE"] = "THRESHOLD_MODE_ABSOLUTE";
    ThresholdMode["THRESHOLD_MODE_PERCENTAGE"] = "THRESHOLD_MODE_PERCENTAGE";
})(ThresholdMode || (ThresholdMode = {}));
